import { matchPath } from "react-router-dom";
import {
  FAILED_DOMAIN_STATUSES,
  SUCCESS_DOMAIN_STATUSES,
  VERIFYING_DOMAIN_STATUSES,
} from "../constants";
import { LANGUAGES_ARRAY } from "../constants/languages";
import { FileEarmark, Folder, Star } from "react-bootstrap-icons";
import { Trans, TransProps } from "react-i18next";
import { ReactElement } from "react";

export const TransElement = Trans as (
  props: TransProps<string>
) => ReactElement;

export enum Error {
  UNIQUE_URL = "Response not successful: Received status code 400",
  PAGE_LIMIT = "You can only create 100 pages.",
  NOT_FOUND_PAGE = "Page not found",
  PUBLISH_LIMIT = "Publish limit",
  SUBSCRIPTION_REQUIRED = "SUBSCRIPTION_REQUIRED",
}

export enum FREE_LIMIT {
  PROJECT = 1,
  PAGE = 100,
  SHARE = 10,
  PUBLISHED_PAGE = 5,
  TEMPLATES = 5,
}

export const TRIAL_TERM = 7;

export function detectLocaleFromUrl(): string | null {
  const path = window.location.pathname;
  const localeMatch = matchPath({ path: "/:locale/*" }, path);

  const locale = localeMatch?.params?.locale;

  if (locale && LANGUAGES_ARRAY.includes(locale)) {
    return locale;
  }

  return null;
}

export enum ITEMS {
  DOMAIN = "domain",
  FOLDER = "folder",
  PAGE = "page",
  FILES = "files",
}

export enum PAYMENT_STATUS {
  FAILED = -1,
  PENDING = 0,
  COMPLETED = 1,
  CANCELED = 3,
  LOADING = 4,
}

export const ACTIVE_TAB = {
  PROJECTS: "projects",
  FOLDERS: "folders",
  PAGES: "pages",
} as const;

export const SHARE_TABS = [
  {
    id: 1,
    name: "projects",
    Icon: Star,
  },
  {
    id: 2,
    name: "folders",
    Icon: Folder,
  },
  {
    id: 3,
    name: "pages",
    Icon: FileEarmark,
  },
];

export const getDomainStatus = (status: string) => {
  if (VERIFYING_DOMAIN_STATUSES.includes(status))
    return { className: "text-warning", text: "Verifying" };
  if (FAILED_DOMAIN_STATUSES.includes(status))
    return { className: "text-danger", text: "Failed" };
  if (SUCCESS_DOMAIN_STATUSES.includes(status))
    return { className: "text-success", text: "Connected" };
  return { className: "text-warning", text: "Verifying" };
};

export const simulateClickOnSupportChat = () => {
  const iframe = document.querySelector('iframe[name="helpcrunch-iframe"]');
  if (!iframe) {
    return;
  }

  window.HelpCrunch("openChat");
};

export const DAYS = [
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
  "Sunday",
];

export const SHORT_DAYS: Record<string, string> = {
  Monday: "Mon",
  Tuesday: "Tue",
  Wednesday: "Wed",
  Thursday: "Thu",
  Friday: "Fri",
  Saturday: "Sat",
  Sunday: "Sun",
};

export const SCHEDULE_FILE_FORMATS =
  ".jpg,.jpeg,.png,.pdf,.vcf,.vcard,.mp4,.mpeg,.ogg,.mp3,.au,.snd,.aif,.aifc,.aiff,.mjs,.pcr,.ppt,.pptm,.pptx,.rtf,.xlsx,.xlsm,.xls,.csv";
